import type { IntentRule } from '@ipfabric/utils';

export const isIntentVerificationAppliedForCurrentTable = (
  selectedTable: string,
  intentRule: IntentRule | null,
): intentRule is IntentRule => intentRule?.webEndpoint === selectedTable;
